module.exports = __webpack_public_path__ + "static/media/mode6.ea62272c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/system/mode6.gif
// module id = 1346
// module chunks = 114